import { EVENTS } from "@/mocks/events";

export default function Hero() {
  const hotTitles = [...EVENTS].sort((a, b) => b.heat - a.heat).map((e) => e.hotTitle);
  const ticker = [...hotTitles, ...hotTitles];

  return (
    <section
      className="relative flex min-h-[560px] w-full flex-col items-center justify-center overflow-hidden md:min-h-[640px]"
      aria-label="网站首屏介绍"
    >
      {/* 背景 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=vibrant%20abstract%20collage%20of%20news%20headlines%20speech%20bubbles%20and%20trending%20hashtag%20icons%20floating%20in%20warm%20coral%20orange%20and%20melon%20green%20gradients%20with%20soft%20cream%20background%2C%20playful%20editorial%20magazine%20style%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=hero-main-2026&orientation=landscape"
          alt="吃瓜资讯首屏背景：温暖的新闻头条与话题气泡拼贴插画"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/60 to-background-50"></div>
      </div>

      {/* 内容 */}
      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 pb-16 pt-6 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50/70 px-4 py-1.5 text-xs font-semibold text-primary-700 backdrop-blur-sm">
          <i className="ri-flashlight-fill text-primary-500" aria-hidden="true"></i>
          不止于爆料 · 更懂来龙去脉
        </span>

        <h1 className="mt-6 font-display text-4xl leading-tight text-foreground-950 md:text-6xl">
          吃瓜资讯
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          从事件梳理到背后真相，再到<strong className="font-semibold text-primary-700">完整时间线</strong>还原，
          我们层层拆解每一个复杂瓜局，用多源交叉求证，帮你<strong className="font-semibold text-accent-700">看清事件全貌</strong>，
          满足每个深度吃瓜党的求知欲。
        </p>

        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href="#hot"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("hot")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
          >
            <i className="ri-fire-line text-lg" aria-hidden="true"></i>
            看看今日热榜
          </a>
          <a
            href="#deep"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("deep")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-primary-300 bg-background-50/60 px-7 py-3.5 text-sm font-semibold text-primary-700 backdrop-blur-sm transition-colors hover:bg-primary-100 sm:w-auto"
          >
            <i className="ri-search-2-line text-lg" aria-hidden="true"></i>
            进入深度解析
          </a>
        </div>

        {/* 微数据 */}
        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-foreground-600">
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-600" aria-hidden="true"></i>
            多源交叉求证
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line text-accent-600" aria-hidden="true"></i>
            完整时间线
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-eye-2-line text-accent-600" aria-hidden="true"></i>
            中立理性呈现
          </span>
        </div>
      </div>

      {/* 滚动热词 */}
      <div className="relative z-10 w-full border-t border-primary-200/60 bg-background-50/70 backdrop-blur-sm">
        <div className="flex items-center gap-3 overflow-hidden py-3">
          <span className="relative z-10 flex shrink-0 items-center gap-1.5 pl-4 text-xs font-bold text-primary-700 md:pl-6">
            <span className="live-dot h-2 w-2 rounded-full bg-primary-500"></span>
            正在热播
          </span>
          <div className="relative flex-1 overflow-hidden [mask-image:linear-gradient(90deg,transparent,#000_8%,#000_92%,transparent)]">
            <div className="flex w-max animate-marquee items-center gap-10">
              {ticker.map((t, idx) => (
                <span
                  key={`${t}-${idx}`}
                  className="flex items-center gap-2 whitespace-nowrap text-sm text-foreground-700"
                >
                  <i className="ri-megaphone-line text-primary-400" aria-hidden="true"></i>
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}